import utils from 'utils'
export default class splitBillRuleModalCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest, logger, resultTipService, $timeout) {
        $scope.ruleList = {}
        $scope.items = items1
        items1.isMerge && httpRequest.post_beforeMergeBill($scope.items.billIdList).then(res => {
            $scope.amountTotal = res.data.value.amountTotal.toFixed(2) || '0.00'
            $scope.billTotal = res.data.value.billTotal
            $scope.custCreditTotal = res.data.value.custCreditTotal
        })
        // 带搜索功能的下拉选择框相关方法
        function toSelect2data(list, idfield, textfield) {
            const result = []
            for (const a in list) {
                const tempdata = {
                    id: '',
                    text: ''
                }
                $.extend(tempdata, list[a])
                tempdata.id = list[a][idfield]
                tempdata.text = list[a][textfield]
                result.push(tempdata)
            }
            return result
        }
        $scope.config3 = {
            allowClear: false
        }

        $scope.config3.data = toSelect2data($scope.items.ruleList, 'ruleSchemaCode', 'ruleSchemaName')
        $scope.aS3 = {}
        $scope.ruleSchemaCode = ''
        if (items1.flag == 2 || items1.flag == 3 || items1.flag == 4) $scope.ruleSchemaCode = '000000'
        if ($scope.items.ruleList && $scope.items.ruleList.length === 1) {
            $timeout(() => {
                $scope.aS3 = {
                    id: '000000',
                    text: '默认规则',
                    ruleSchemaCode: '000000',
                }
                $scope.ruleSchemaCode = '000000'
            })
        }

        $scope.check = function (v) {
            const reg = /^[0-9]*$/g
            if (v && $scope.endRow) {
                if (!reg.test($scope.endRow) || $scope.endRow > 2000 || $scope.endRow < 1) {
                    $scope.endRow = ''
                    $scope.showTips = true
                }
                if ($scope.startRow && +$scope.startRow > +$scope.endRow) $scope.endRow = ''
            } else if ($scope.startRow) {
                if (!reg.test($scope.startRow) || $scope.startRow < 1 || $scope.startRow > 2000) {
                    $scope.startRow = ''
                    $scope.showTips = true
                }
                if ($scope.endRow && +$scope.startRow > +$scope.endRow) $scope.startRow = ''
            }
        }
        $scope.ok = function () {
            if (!$scope.ruleSchemaCode) {
                logger.logError('请先选择拆和规则')
                return
            }
            utils.loading('销售单处理中')
            $scope.ruleList.ruleSchemaCode = $scope.aS3.ruleSchemaCode
            // console.log($scope.ruleList.ruleSchemaCode)

            if ($scope.items.flag == 1) {
                httpRequest.get_autoSpiltBill($scope.items.billId, $scope.ruleList.ruleSchemaCode, '拆分销售单成功').then((res) => {
                    $uibModalInstance.close()
                    utils.loaded()
                })
            } else if ($scope.items.flag == 2) {
                httpRequest.get_billCommit($scope.items.billId, $scope.ruleList.ruleSchemaCode, '销售单提交成功').then((res) => {
                    $uibModalInstance.close()
                    utils.loaded()
                })
            } else if ($scope.items.flag == 3) {
                if ($scope.startRow || $scope.endRow) {
                    $uibModalInstance.close({
                        billRuleCode: $scope.ruleList.ruleSchemaCode,
                        endRow: $scope.endRow,
                        startRow: $scope.startRow
                    })
                } else {
                    httpRequest.get_billBatchCommit({
                        billIdList: $scope.items.billIdList,
                        billRuleCode: $scope.ruleList.ruleSchemaCode
                    }).then((res) => {
                        utils.loaded()
                        if (res.data.value.error) {
                            const params = {
                                sourceCount: res.data.value.total,
                                errorCount: res.data.value.error,
                                list: res.data.value.messageList,
                                title: '提交'
                            }
                            resultTipService.openErrorModal(params, $uibModalInstance.close)
                        } else {
                            logger.logSuccess(`提交成功${res.data.value.total}张票据`)
                            $uibModalInstance.close()
                        }
                    })

                }
            } else if ($scope.items.flag == 4) {
                httpRequest.get_mergeBill({
                    billIdList: $scope.items.billIdList,
                    billRuleCode: $scope.ruleList.ruleSchemaCode
                }, '合并销售单成功').then((res) => {
                    $uibModalInstance.close(res)
                    utils.loaded()
                })
            }
        }

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/ovatBill/splitBillRuleModalCtrl.js